import * as React from "react";
import { Profile } from "../../../models/Profile";
import { SilModal } from "../../SilModal";
import { CancelSubmitButtons } from "../shared/CancelSubmitButtons";
import { ErrorMessage } from "../shared/ErrorMessage";
import { InputField, ValidatedField } from "../shared/forms";
import { ProfileFormOptions } from "./ProfileFormOptions";
import { nonEditableProfile } from "../shared/helpers";

interface Props {
  profile?: Profile;
  errorMessage?: string;
  closeModal: () => void;
  saveProfile: (profile: Profile) => void; 
  updateProfile: (profile: Profile) => void;
}

interface State {
  name: ValidatedField<string>;
  profile: Profile;
}

export class ProfileModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const name: ValidatedField<string> = { value: "", isValid: true, message: "" }
    if (props.profile) {
      name.value = props.profile.name;
    }
    this.state = {
      name: name,
      profile: props.profile ?? new Profile(),
    };
  }

  onValidatedNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const nameField = { ... this.state.name };
    nameField.value = value;

    this.setState({ name: nameField });
  }

  formIsValid = () => {
    const name = this.state.name;
    let isValid = true;
    if (name.value == null || name.value == "") {
      name.isValid = false;
      name.message = "* A profile name is required"
      isValid = false;
    }

    if (!isValid) {
      this.setState({ name });
    }

    return isValid;
  }

  resetValidationStates = () => {
    const state = JSON.parse(JSON.stringify(this.state));
    Object.keys(state).map(key => {
      if(state[key] && state[key].hasOwnProperty("isValid")) {
        state[key].isValid = true;
        state[key].message = "";
      }
    })
  }

  onSubmit = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    this.resetValidationStates();
    if (!this.formIsValid()) { return; }

    if (this.props.profile == null) {
      const newProfile = { ... this.state.profile };
      newProfile.name = this.state.name.value;
      this.props.saveProfile(newProfile);
    } else {
      const updatedProfile = { ... this.state.profile };
      updatedProfile.name = this.state.name.value;
      this.props.updateProfile(updatedProfile);
    }
  }

  onDescriptionFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const profile = { ...this.state.profile };
    profile.description = e.target.value;
    this.setState({ profile });
  }

  onProfilePropertyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const profile = { ...this.state.profile };
    profile[e.target.name] = e.target.checked;

    if (e.target.name == "userTab" && e.target.checked) {
      profile["viewUsers"] = true;
    }
    if (e.target.name == "areaTab" && e.target.checked) {
      profile["viewAreas"] = true;
      profile["editSites"] = false;
    }
    if (e.target.name == "editSites" && e.target.checked) {
      profile["areaTab"] = false;
    }

    this.setState({ profile });
  }

  render() {
    return (
      <SilModal
        title={this.props.profile ? "Edit profile" : "New profile"}
        closeModal={this.props.closeModal}
      >
        <form noValidate autoComplete="off">
          <InputField
            label="Name"
            type="text"
            name="name"
            placeholder="Profile name..."
            value={this.state.name.value}
            onChange={this.onValidatedNameChange}
            invalid={!this.state.name.isValid}
            feedback={this.state.name.message}
            autoFocus={true}
            disabled={nonEditableProfile(this.props.profile) }
          />
          <InputField
            label="Description"
            name="description"
            type="text"
            placeholder="Profile description..."
            value={this.state.profile.description}
            onChange={this.onDescriptionFieldChange}
          />
          <ProfileFormOptions
            profile={this.state.profile}
            onChange={this.onProfilePropertyChange}
            disabled={this.state.profile?.name == "Admin" || this.state.profile?.name == "Read Only"}
          />
          <ErrorMessage message={this.props.errorMessage} />
          <CancelSubmitButtons
            submitText="Save profile"
            closeModal={this.props.closeModal}
            onSubmit={e => this.onSubmit(e)}
          />
        </form>
      </SilModal>
    )
  }
}